import {AppState} from "../index";

export const getCommentsSelector = (state: AppState) => {
  return state.comments
}